import { useMutation } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

interface body {
    idx: (number | string)[];
    category: number;
}

// 게시글 삭제
export const useDelBoard = () => {
    return useMutation({
        mutationFn: async (body: body) => {
            const res = await consoleAxios.delete(CONSOLE_API_ROUTES.BOARD_MANAGE, {
                data: body,
            });
            return res.data;
        },
    });
};
